import Axios from '@/assets/js/AxiosPlugin'

// 获取余额（不随筛选时间变化）
export const statisticsBalance = params => { return Axios.post('/api/Admin/Statistics/balance', params) }

// 按筛选时间统计充值、消费总计
export const statisticsRecords = params => { return Axios.post('/api/Admin/Statistics/records', params) }



// WEBPACK FOOTER //
// ./src/views/webpc/CashierDesk/CheckingApp/apis/index.js